export const validateNumber = (value: any) => {
    const matches = value.match(
        /^(?:0\.(?:0[0-9]|[0-9]\d?)|[0-9]\d*(?:\.\d{1,2})?)(?:e[+-]?\d+)?$/,
    );

    return matches?.length > 0 || 'Please enter a number';
};
